import React from "react";
import Typography from "../../../../components/Typography/Typography";
import RecordForm from "../BatchRecords/RecordForm";
import { Form } from "../../../../components/forms";

const InfoCard = ({ icon, label, value, children, className = "" }) => {
    return (
        <div
            className={`d-flex align-items-start p-3 rounded ${className}`}
            style={{
                backgroundColor: "#ffffff",
                border: "1px solid #e2f1ff",
            }}
        >
            <div className="me-3 mt-1">
                <div
                    className="rounded-circle d-flex align-items-center justify-content-center"
                    style={{
                        width: "32px",
                        height: "32px",
                        backgroundColor: "#dbe5f0",
                        color: "#1c8ad1",
                    }}
                >
                    <i className={`bi bi-${icon}`}></i>
                </div>
            </div>
            <div>
                <Typography
                    variant="body2"
                    className="text-muted mb-1 fw-medium"
                >
                    {label}
                </Typography>
                {value && (
                    <Typography
                        variant="body1"
                        className="fw-semibold m-0"
                        style={{ color: "#2d4a66" }}
                    >
                        {value}
                    </Typography>
                )}
                {children}
            </div>
        </div>
    );
};

const UnitBadges = ({ units }) => {
    if (!units || units.length === 0) {
        return (
            <Typography variant="body2" className="text-muted">
                No units available
            </Typography>
        );
    }

    return (
        <div className="d-flex flex-wrap gap-2">
            {units.map((unit) => (
                <span
                    key={unit.id}
                    className="badge rounded-pill"
                    style={{
                        backgroundColor: "#dbe5f0",
                        color: "#1c8ad1",
                        fontSize: "0.75rem",
                        padding: "0.5rem 0.875rem",
                        fontWeight: "500",
                        border: "1px solid #c6e3ff",
                    }}
                >
                    {unit.name} ({unit.symbol})
                </span>
            ))}
        </div>
    );
};

function SelectAssetType({
    selectedAssetType,
    assetTypeList,
    onAssetTypeChange,
}) {
    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12 pt-2">
                    <Typography variant="h3" className="mb-2">
                        Select Asset Type
                    </Typography>
                    <Typography variant="body1" className="mb-4">
                        Choose the type of assets you want to extract from your
                        documents
                    </Typography>
                    <Form>
                        <RecordForm
                            fieldType="dropdown"
                            name="asset_type"
                            label="Material type"
                            options={assetTypeList}
                            onChange={onAssetTypeChange}
                            isRequired={true}
                            key="asset_type"
                            disabled={false}
                            value={selectedAssetType?.value || ""} 
                        />
                    </Form>

                    {/* Selected Asset Type Card */}
                    {selectedAssetType && (
                        <div className="mt-4">
                            <div
                                className="card border-0"
                                style={{
                                    backgroundColor: "transparent",
                                    transition: "none",
                                    boxShadow: "none",
                                }}
                            >
                                <div className="card-body p-4">
                                    {/* Header Section */}
                                    <div className="d-flex align-items-center mb-4 pb-3 border-bottom">
                                        <div className="me-3">
                                            <div
                                                className="rounded-circle d-flex align-items-center justify-content-center"
                                                style={{
                                                    width: "52px",
                                                    height: "52px",
                                                    backgroundColor: "#dbe5f0",
                                                    color: "#1c8ad1",
                                                }}
                                            >
                                                <i className="bi bi-box-seam fs-4"></i>
                                            </div>
                                        </div>
                                        <div>
                                            <Typography
                                                variant="h5"
                                                className="mb-1 fw-semibold"
                                            >
                                                {selectedAssetType.label}
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                className="text-muted m-0 p-0"
                                            >
                                                Asset Type Selected
                                            </Typography>
                                        </div>
                                    </div>

                                    {/* Content Grid */}
                                    <div className="row g-4">
                                        <div className="col-md-6">
                                            <InfoCard
                                                icon="tag"
                                                label="Material Type"
                                                value={
                                                    selectedAssetType.material_type ||
                                                    "Not specified"
                                                }
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <InfoCard
                                                icon="rulers"
                                                label="Unit Category"
                                                value={
                                                    selectedAssetType
                                                        .unit_category?.name ||
                                                    "Not specified"
                                                }
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <InfoCard
                                                icon="geo-alt"
                                                label="Location"
                                                value={
                                                    selectedAssetType.location
                                                        ?.name ||
                                                    "Not specified"
                                                }
                                            >
                                                {selectedAssetType.location
                                                    ?.location && (
                                                    <Typography
                                                        variant="body2"
                                                        className="text-muted mt-1"
                                                    >
                                                        (
                                                        {
                                                            selectedAssetType
                                                                .location
                                                                .location
                                                        }
                                                        )
                                                    </Typography>
                                                )}
                                            </InfoCard>
                                        </div>

                                        <div className="col-md-6">
                                            <div
                                                className="p-3 rounded"
                                                style={{
                                                    backgroundColor: "#ffffff",
                                                    border: "1px solid #e2f1ff",
                                                }}
                                            >
                                                <div className="d-flex align-items-center mb-3">
                                                    <div className="me-3 mt-1">
                                                        <div
                                                            className="rounded-circle d-flex align-items-center justify-content-center"
                                                            style={{
                                                                width: "32px",
                                                                height: "32px",
                                                                backgroundColor:
                                                                    "#dbe5f0",
                                                                color: "#1c8ad1",
                                                            }}
                                                        >
                                                            <i className="bi bi-list-check"></i>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <Typography
                                                            variant="body2"
                                                            className="text-muted mb-1 fw-medium"
                                                        >
                                                            Available Units
                                                        </Typography>
                                                    </div>
                                                </div>
                                                <UnitBadges
                                                    units={
                                                        selectedAssetType
                                                            .unit_category
                                                            ?.units
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}

export default SelectAssetType;
